export const QUERY_REMORTGAGE = "remortgage";
export const QUERY_FIRST_TIME_BUYER = "first-time-buyer";
export const QUERY_HOME_MOVER = "home-mover";
